import React from "react";
import SpecialAgentReportPage from "@/components/reports/SpecialAgentReportPage";

/** Aynı veri/API; modern glass + animasyonlu arayüz (v2). */
const SpecialAgentReportPageV2 = (props) => (
  <SpecialAgentReportPage
    {...props}
    variant="v2"
    pageTitle="Özel Asistan Raporu 2"
    pageSubtitle="Sunum analitiği · TL×Kalite · 6 modül grafik özeti"
    storageKey="specialAgentReportState_v2"
  />
);

export default SpecialAgentReportPageV2;
